import SessionService from './SessionService';
import ImagePlayer from './Players/ImagePlayer';
import VideoPlayer from './Players/VideoPlayer';

export default class ResultCollector {
    /**
     * ResultCollector constructor
     *
     * @param {SessionService} sessionService
     */
    constructor(sessionService) {
        this.startTime = null;
        this.pollingResults = [];
        this.players = [];
        this.sessionService = sessionService;
        this.pollingInterval = null;
    }

    start(players) {
        this.players = players;
        this.startTime = window.performance.now();

        try {
            this.startPlayerPolling();
        } catch (e) {
            //todo send log
        }
    }

    addInfo(info, elementType) {
        if (info) {
            const res = {
                time: this._getTime(),
                elementType: elementType,
                externalInfo: typeof (info) === "object" ? JSON.stringify(info) : info
            };

            this.pollingResults.push(res);
        }
    }

    startPlayerPolling() {
        const getPosition = async () => {
            const activePlayer = this.players.find(player => player.isActive);
            if (!activePlayer) {
                return;
            }

            const position = activePlayer.getPosition();
            if (position && position.elementId && position.position !== null && position.position !== undefined) {
                position.time = this._getTime();
                if (this.pollingResults.length > 100) {
                    await this.savePoll(false);
                }

                if (position.elementId > 0) {
                    position.elementDisplaySeqNum = this._getMediaElementDisplayNumberById(position.elementId);
                }

                if (activePlayer.testElement && activePlayer.testElement.globalKey) {
                    position.globalKey = activePlayer.testElement.globalKey;
                }

                this.pollingResults.push(position);
            }
        };

        this.players.forEach(player => {
            player.onStateChange(getPosition);
        });

        this.pollingInterval = setInterval(async () => {
            await getPosition();
        }, 500);
    }

    stopPlayerPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
        }
    }

    async savePoll(isFinal) {
        try {
            const tmp = this.pollingResults;
            this.pollingResults = [];
            await this.sessionService.logMessage('info', 'videoPlayer.pollingResults: ' + JSON.stringify(tmp));
            await this.sessionService.saveSessionResults({
                batch: tmp,
                isFinal: isFinal
            });
        } catch (e) {
            //todo:add log errors
        }

        return {};
    }

    _getTime() {
        return Math.round(window.performance.now() - this.startTime);
    }

    _getMediaElementDisplayNumberById(elementId) {
        const mediaPlayers = this.players.filter(p => p instanceof ImagePlayer || p instanceof VideoPlayer);

        return mediaPlayers.findIndex(p => p.testElement.testElementSequenceID === elementId);
    }
}
